import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from 'intl/messages';
import { Form, FormField } from '../form';

const fields: FormField[] = [
  {
    type: 'password',
    name: 'oldPassword',
    label: <FormattedMessage {...messages.oldPassword} />,
  },
  {
    type: 'password',
    name: 'password',
    label: <FormattedMessage {...messages.password} />,
  },
  {
    type: 'password',
    name: 'password2',
    label: <FormattedMessage {...messages.confirmPassword} />,
  },
];

export interface PasswordValues {
  oldPassword: string;
  password: string;
  password2: string;
}

interface PasswordFormErrors {
  oldPassword?: React.ReactNode;
  password?: React.ReactNode;
  password2?: React.ReactNode;
}

export const validatePasswords = (values: PasswordValues) => {
  const errors: PasswordFormErrors = {};
  if (!values.oldPassword) {
    errors.oldPassword = <FormattedMessage {...messages.required} />;
  }
  if (!values.password) {
    errors.password = <FormattedMessage {...messages.required} />;
  }
  if (!values.password2) {
    errors.password2 = <FormattedMessage {...messages.required} />;
  } else if (values.password !== values.password2) {
    errors.password2 = <FormattedMessage {...messages.passwordsMustMatch} />;
  }
  return errors;
};

interface PasswordFormProps {
  onSubmit: (values: PasswordValues) => void;
  loading?: boolean;
}

export const PasswordForm: React.FC<PasswordFormProps> = ({ onSubmit, ...props }) => (
  <Form<PasswordValues>
    {...props}
    onSubmit={onSubmit}
    fields={fields}
    hideCancel
    submitLabel={<FormattedMessage {...messages.changePassword} />}
    validate={validatePasswords}
    initialValues={{ oldPassword: '', password: '', password2: '' }}
  />
);
